import React from 'react'
import delivered from '../assets/icons/sre-boat.svg'
import downhole from '../assets/icons/sre-downhole.svg'
import returned from '../assets/icons/sre-returned.svg'
import rejected from '../assets/icons/sre-rejected.svg'

import { ReactComponent as UkFlag } from '../assets/icons/uk-flag.svg'
import { ReactComponent as UsaFlag } from '../assets/icons/usa-flag.svg'
import { ReactComponent as BrazilFlag } from '../assets/icons/brazil-flag.svg'
import { ReactComponent as GermanyFlag } from '../assets/icons/germany-flag.svg'
import { ReactComponent as AlbaniaFlag } from '../assets/icons/albania-flag.svg'
import { ReactComponent as IndonesiaFlag } from '../assets/icons/indonesia-flag.svg'
import { ReactComponent as AzerbaijanFlag } from '../assets/icons/azerbaijan-flag.svg'
import { ReactComponent as AlgeriaFlag } from '../assets/icons/algeria-flag.svg'
import { ReactComponent as DefaultFlag } from '../assets/icons/default-flag.svg'

export const summaryIconsMap = {
    delivered: delivered,
    downhole: downhole,
    returned: returned,
    rejected: rejected
}

const jobsCountryIconsStyle = { width: '30px', height: '30px' }
export const jobsCountryIconsMap = {
    'United Kingdom': <UkFlag style={jobsCountryIconsStyle} />,
    'Brazil': <BrazilFlag style={jobsCountryIconsStyle} />,
    'USA': <UsaFlag style={jobsCountryIconsStyle} />,
    'Germany': <GermanyFlag style={jobsCountryIconsStyle} />,
    'Albania': <AlbaniaFlag style={jobsCountryIconsStyle} />,
    'Indonesia': <IndonesiaFlag style={jobsCountryIconsStyle} />,
    'Azerbaijan': <AzerbaijanFlag style={jobsCountryIconsStyle} />,
    'Algeria': <AlgeriaFlag style={jobsCountryIconsStyle} />,
    'default': <DefaultFlag style={jobsCountryIconsStyle} />,
}

export const S3_TYPE_MAP = {
    'xls': 'application/vnd.ms-excel',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'xltx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'xlsm': 'application/vnd.ms-excel.sheet.macroEnabled.12',
    'xltm': 'application/vnd.ms-excel.template.macroEnabled.12',
    'xlam': 'application/vnd.ms-excel.addin.macroEnabled.12',
    'xlsb': 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'pdf': 'application/pdf',
    'jpeg': 'image/jpeg',
    'jpg': 'image/jpeg',
    'svg': 'image/svg+xml',
    'png': 'image/png',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}

export const TYPE_MAP = {
    'xls': 'XLS',
    'xlsx': 'XLSX',
    'xltx': 'XLTX',
    'xlsm': 'XLSM',
    'xltm': 'XLTM',
    'xlam': 'XLAM',
    'xlsb': 'XLSB',
    'pdf': 'PDF',
    'jpeg': 'JPEG',
    'jpg': 'JPG',
    'svg': 'SVG',
    'png': 'PNG',
    'doc': 'DOC',
    'docx': 'DOCX'
}